/* template */
<template><div><TsButton v-for="(item, index) in (helpList)" :key="item.type" :class="({online:item.type === 'onlineHelp'})" @click="handleHelpClick(item)" class="help-item"><mpx-image mode="widthFix" :src="(item.icon)" class="help-item-icon"/><div class="help-item-title"><div>{{item.title}}</div><div v-show="(item.subTitle)" class="help-item-subtitle">{{item.subTitle}}</div></div><div class="help-item-content"><div class="help-item-content-btn" v-if="(item.type === 'onlineHelp')">客服</div><div v-else>{{item.content}}</div></div></TsButton></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m047c6ed7"}'>
.help-item
  margin 0 16px 10px
  padding 12px 16px
  display flex
  align-items center
  border-radius 10px
  background linear-gradient(270deg, #F2F6F9 12%, rgba(242, 246, 249, 0.3) 100%)
  overflow hidden
  &:first-child
    margin-top 6px
  &:last-child
    margin-bottom 58px
  &-icon
    width 32px
    height 32px
    flex none
    margin-right 12px
  &-title
    line-height 1
    display flex
    flex 1
    flex-direction column
    justify-content center
    align-items flex-start
    white-space nowrap
    font-family PingFangSC-Medium
    font-weight 500
    color #222
    font-size 16px
  &-subtitle
    font-family PingFangSC-Regular, PingFangSC, Helvetica, Arial, sans-serif
    font-weight 400
    color #666
    font-size 12px
    margin-top 7px
  &-content
    flex none
    line-height 1
    color #666
    font-size 14px
    &-btn
      position relative
      display flex
      align-items center
      justify-content center
      color #fff
      width 75px
      height 32px
      font-family PingFangSC-Medium
      font-weight 500
      font-size 14px
      border-radius 7px
      background #338FFF
      &::after
        font-family PingFangSC-Medium
        padding 3px 7px
        font-weight 500
        font-size 9px
        position absolute
        content '推荐'
        background linear-gradient(180deg, #FF8C00 6%, #FF6A00 100%)
        border 0.5px solid #FFFFFF
        border-radius 8px 8px 8px 0
        right 0
        bottom 27px
  &.online
    padding 20px 16px
    .help-item-icon
      width 44px
      height 44px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m047c6ed7"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex047c6ed7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex047c6ed7%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m047c6ed7"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index047c6ed7/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'TsButton':getComponent(require("../ts-button/index.mpx?isComponent&outputPath=components%2Findex9b0ba146%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
